/**
 * Gets the full portal domain hostname used for API calls.
 *
 * @param getParent - If true (default), returns the parent domain by stripping subdomain. If false, returns the current hostname.
 * @returns The portal domain hostname (e.g., 'app.adbox.pro')
 */

// NOTE: Should change this param to true
export function getPortalDomain(getParent = false): string {
  if (import.meta.env.DEV) {
    return import.meta.env.VITE_PORTAL_DOMAIN || 'roimatic.adbox.pro';
  }

  const domain = getParent
    ? getParentDomain(window.location.hostname)
    : window.location.hostname;
  return domain;
}

const getParentDomain = (hostname: string): string => {
  return hostname.split('.').slice(1).join('.');
};

/**
 * Root domain — used for cookie Domain attribute (e.g. 'adbox.pro')
 * Strips subdomains so cookies work across all subdomains.
 * Falls back to 'localhost' in dev.
 */
export function getCookieDomain(): string {
  if (import.meta.env.DEV) {
    return 'localhost';
  }
  return window.location.hostname.split('.').slice(-2).join('.');
}

/**
 * Login URL — picks Stunnr login for stunnr.co domains, Roimatic login otherwise.
 * Dev always uses VITE_APP_LOGIN_URL.
 */
export function getLoginUrl(): string {
  const stunnrUrl = import.meta.env.VITE_APP_LOGIN_URL;
  const roimaticUrl = import.meta.env.VITE_APP_ROIMATIC_LOGIN_URL;
  if (import.meta.env.DEV) return stunnrUrl;
  const host = window.location.hostname;
  const isStunnr = host === 'stunnr.co' || host.endsWith('.stunnr.co');
  return isStunnr ? stunnrUrl : roimaticUrl || stunnrUrl;
}

/**
 * Variant Builder app URL. Auth is shared via the
 * cookie Domain attribute (see getCookieDomain), so no token needs to
 * be passed when redirecting to it.
 */
export function getVariantBuilderUrl(): string {
  return import.meta.env.VITE_APP_VARIANT_BUILDER_URL;
}
